import accordion from './accordion';
import button from './button';
import checkbox from './checkbox';
import colour from './colour';
import dateTime from './date-time';
import dropdown from './dropdown';
import footer from './footer';
import form from './form';
import grid from './grid';
import heading from './heading';
import icon from './icon';
import modal from './modal';
import nav from './nav';
import notification from './notification';
import packageCard from './package-card';
import packagesRow from './packages-row';
import quoteButton from './quote-button';
import quoteProgress from './quote-progress';
import radioButton from './radio-button';
import separator from './separator';
import slideToggle from './slide-toggle';
import table from './table';
import tabs from './tabs';
import textInput from './text-input';
import tooltip from './tooltip';
import font from './font';
import transition from './transition';
import utilities from './utilities';
import zIndexes from './z-indexes';
import textArea from './text-area';
import switchVars from './switch';

export const sonnet = {
  accordion,
  button,
  checkbox,
  colour,
  dateTime,
  dropdown,
  footer,
  form,
  grid,
  heading,
  icon,
  modal,
  nav,
  notification,
  packageCard,
  packagesRow,
  quoteButton,
  quoteProgress,
  radioButton,
  separator,
  slideToggle,
  table,
  tabs,
  textInput,
  tooltip,
  font,
  transition,
  utilities,
  zIndexes,
  textArea,
  switch: switchVars,
};
